import * as React from 'react';

import * as CheckboxPrimitive from '@radix-ui/react-checkbox';

import { VariantProps, cva } from 'class-variance-authority';

import { CheckIcon } from '../assets';
import { cn } from '../lib';

const checkboxVariants = cva(
  'shrink-0  peer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default:
          'data-[state=checked]:border-primary border border-white data-[state=checked]:bg-brand-500 data-[state=checked]:text-primary-foreground [&>span>svg]:text-base-500',
        secondary:
          'border-2 border-icon-base-100 data-[state=checked]:bg-icon-base-500 data-[state=checked]:text-icon-contrast-500 data-[state=checked]:border-transparent [&>span>svg]:text-icon-contrast-500',
        //deprecated
        dashboard:
          'border-2 border-icon-base-100 data-[state=checked]:bg-icon-base-500 data-[state=checked]:text-icon-contrast-500 data-[state=checked]:border-transparent [&>span>svg]:text-icon-contrast-500',
      },
      size: {
        default: 'h-4 w-4 rounded-sm',
        md: 'h-[18px] w-[18px] rounded-[5px] [&>span>svg]:stroke-[3]',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
);
interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
    VariantProps<typeof checkboxVariants> {}
const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  CheckboxProps
>(({ className, variant, size, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(checkboxVariants({ variant, size, className }))}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={cn('flex items-center justify-center text-current')}
    >
      <CheckIcon className="w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
